module.exports = __webpack_public_path__ + "img/wool_md.8a4c637.webp";